module.exports = __webpack_public_path__ + "static/img/RWA1564-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA1564-G_1.png
// module id = Fs2L
// module chunks = 0